var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcon05(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.2,
    height: 17.9,
    viewBox: "0 0 18.2 17.9",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1966",
    "data-name": "Trac\\xE9 1966",
    d: "M3.525,8.525c0-1.25.55-1.725,1.425-1.725s1.425.475,1.425,1.725v9.45c0,1.25-.55,1.725-1.425,1.725s-1.425-.475-1.425-1.725ZM.775,17.8c0,2.8,1.475,4.4,4.175,4.4s4.175-1.6,4.175-4.4V8.7c0-2.8-1.475-4.4-4.175-4.4S.775,5.9.775,8.7Zm10-1.45V17.8c0,2.8,1.4,4.4,4.1,4.4s4.1-1.6,4.1-4.4V13.9c0-2.575-1.025-4-3.05-4a2.583,2.583,0,0,0-2.375,1.275H13.5L13.725,7h4.8V4.5h-7.25l-.5,10.15h2.6v-.525c0-1.25.55-1.725,1.425-1.725s1.425.475,1.425,1.725v3.85c0,1.25-.55,1.7-1.425,1.7s-1.425-.45-1.425-1.7V16.35Z",
    transform: "translate(-0.775 -4.3)",
    fill: "#d38f7a"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon05);
export default __webpack_public_path__ + "static/media/icon-05.88f39375e58286298ef39d3c9fff4ef6.svg";
export { ForwardRef as ReactComponent };